import { handleWindow } from '@/utils';
const win = handleWindow();

// common
const LIGHT_H5_PV = 'light_H5_pv';
const LIGHT_H5_SHOT_CLICK = 'light_H5_shot_click';
const LIGHT_H5_DOWNLOAD_BUTTON_CLICK = 'light_H5_download_button_click';
const LIGHT_H5_SHARE_CLICK = 'light_H5_share_click';
const LIGHT_H5_TRYNOW_CLICK = 'light_H5_trynow_click';
const LIGHT_H5_VIDEO_PLAY_CLICK = 'light_H5_video_play_click';
const LIGHT_H5_VIDEO_TRYNOW_CLICK = 'light_H5_video_trynow_click';
const LIGHT_H5_VIDEO_PLAY_PV = 'light_H5_video_play_pv';
const LIGHT_CALLBACK_CLICK = 'light_callback_click';
const LIGHT_H5_RULES_OPEN_CLICK = 'light_h5_rules_open_click';
const LIGHT_H5_RULES_CLOSE_CLICK = 'light_h5_rules_close_click';
const LIGHT_H5_VIDEO_MODEL_TRYNOW_CLICK = 'light_H5_video_model_trynow_click';

// fireFighting
const FIRE_FIGHTING_PAGE_TITLE = 'firefighting';

// topic
const LIGHT_H5_MODEL_BACK_TO_APP = 'light_H5_model_back_to_app';
const LIGHT_H5_MODEL_COVER_CLICK = 'light_H5_model_cover_click';

// Template Type Tab
const LIGHT_H5_TAB_CLICK = 'light_H5_tab_click';
const LIGHT_H5_BUYNOW_CLICK = 'light_H5_buynow_click';

// fly导流light
const FLY_H5_TRYNOW = 'fly_h5_trynow';

// work detail
export const WORK_DETAIL_PAGE_TITLE = 'ugc_model_share';

// template detail
export const TEMPLATE_DETAIL_PAGE_TITLE = 'pgc_model_share';

/** 创意 h5 pv */
export const LIGHT_CREATIVE_H5_PV = 'light_creative_H5_pv'
/** 创意 h5 分享 */
export const LIGHT_CREATIVE_H5_SHARE_CLICK = 'light_creative_H5_share_click'
/** 创意 h5 试试看 */
export const LIGHT_CREATIVE_H5_TRY_CLICK = 'light_creative_H5_try_click'
/** 创意 h5 点击播放按钮 */
export const LIGHT_CREATIVE_H5_PLAY_CLICK = 'light_creative_H5_play_click'

const EVENT_NAME_COLLECTION = {
  LIGHT_H5_PV,
  LIGHT_H5_SHOT_CLICK,
  LIGHT_H5_DOWNLOAD_BUTTON_CLICK,
  LIGHT_H5_SHARE_CLICK,
  LIGHT_H5_VIDEO_PLAY_CLICK,
  LIGHT_H5_VIDEO_TRYNOW_CLICK,
  LIGHT_H5_VIDEO_PLAY_PV,
  LIGHT_H5_TRYNOW_CLICK,
  LIGHT_CALLBACK_CLICK,
  LIGHT_H5_MODEL_BACK_TO_APP,
  LIGHT_H5_MODEL_COVER_CLICK,
  LIGHT_H5_BUYNOW_CLICK,
  LIGHT_H5_TAB_CLICK,
  FLY_H5_TRYNOW,
  LIGHT_H5_VIDEO_MODEL_TRYNOW_CLICK,
};

export default EVENT_NAME_COLLECTION;

export const fireFightingSensors = {
  LIGHT_H5_PV,
  LIGHT_H5_VIDEO_PLAY_CLICK,
  LIGHT_H5_DOWNLOAD_BUTTON_CLICK,
  FIRE_FIGHTING_PAGE_TITLE,
};

export const competitionConstants = {
  LIGHT_H5_RULES_OPEN_CLICK,
  LIGHT_H5_RULES_CLOSE_CLICK,
  LIGHT_H5_TRYNOW_CLICK,
  LIGHT_H5_VIDEO_PLAY_CLICK,
};

export const H5Types = {
  hardware: 'hardware', // 硬件H5
  topic: 'topic', // 话题H5
  template_share: 'template_share', // 模板分享H5
  video_share: 'video_share', // 个人作品分享H5
  template_recommend: 'template_recommend', // 模板推荐H5
  creative_content: 'creative_content', // 创意内容H5
  other: 'other', // 其余页面
}


export const getTrackPageType = () => {
  const { pathname } = win.location;
  if (pathname.indexOf('/share/template') > -1 || pathname.indexOf('/share/templates') > -1) {
    return H5Types.template_share;
  } else if (pathname.indexOf('/share/work') > -1 || pathname.indexOf('/share/videos') > -1) {
    return H5Types.video_share;
  } else if (pathname.indexOf('/topic') > -1) {
    return H5Types.topic;
  } else if (pathname.indexOf('/activity/center') > -1) {
    return H5Types.template_recommend;
  }  else if (pathname.indexOf('/activity/creativity') > -1) {
    return H5Types.creative_content;
  } else if (pathname.indexOf('/activity/action2-and-pocket2') > -1 || pathname.indexOf('/activity/om5') > -1) {
    return H5Types.hardware;
  }
  return H5Types.other;
};
